import { RefObject, createContext } from 'preact'
import { MutableRef, useContext } from 'preact/hooks'

const ChatScrollContext = createContext<{
  eventRefs: Record<string, RefObject<HTMLElement | null>>
  unreadIds: (string | undefined)[]
  scrollToRef: () => void
  scrollToBottom: () => void
  containerRef: MutableRef<HTMLDivElement | null>
} | null>(null)

export const useChatScrollContext = () => {
  const context = useContext(ChatScrollContext)

  if (!context) {
    throw new Error(
      'useChatScrollContext has to be used within <ChatScrollContext.Provider>',
    )
  }

  return context
}

export default ChatScrollContext
